import { matchIndicatorKey } from "@components/HeaderDashboardCards/matchIndicatorKey";

export const MANAGER_FILTER_LABELS = Object.freeze({
  HAS: "Has Manager",
  NONE: "Does Not Have Manager",
});

export const DEPARTMENT_MANAGER_FILTER_GROUPS = Object.freeze([
  {
    label: "Manager",
    items: [
      { label: "No Filter", value: "No Filter" },
      { label: MANAGER_FILTER_LABELS.HAS, value: MANAGER_FILTER_LABELS.HAS },
      { label: MANAGER_FILTER_LABELS.NONE, value: MANAGER_FILTER_LABELS.NONE },
    ],
  },
]);

/** Header-dashboard tile key -> the full filter combination it applies. Unassigned Positions has none. */
export const DEPARTMENT_INDICATOR_FILTERS = Object.freeze({
  active: Object.freeze(["active"]),
  draft: Object.freeze(["draft"]),
  "not-managed": Object.freeze(["active", MANAGER_FILTER_LABELS.NONE]),
});

const normalizeFilter = (filter) =>
  String(typeof filter === "string" ? filter : filter?.value || "")
    .trim()
    .toLowerCase();

/** ER-12619: radio "No Filter" and "Do not Show" archived never render as chips. */
const DEPARTMENT_INDICATOR_NEUTRAL_VALUES = Object.freeze(["No Filter", "no_archived"]);

/** Key of the tile whose combination equals the applied filters (neutral values ignored), else null. */
export const resolveActiveIndicatorKey = (appliedFilters = []) =>
  matchIndicatorKey(
    appliedFilters,
    DEPARTMENT_INDICATOR_FILTERS,
    DEPARTMENT_INDICATOR_NEUTRAL_VALUES
  );

/** `has_manager` API value for the applied Manager radio, or undefined when no Manager filter. */
export const resolveHasManagerFilter = (appliedFilters = []) => {
  const applied = (appliedFilters || []).map(normalizeFilter);
  if (applied.includes(MANAGER_FILTER_LABELS.NONE.toLowerCase())) return false;
  if (applied.includes(MANAGER_FILTER_LABELS.HAS.toLowerCase())) return true;
  return undefined;
};
